<template>
  <div class="a-m-us a-aui_72554-c a-aui_killswitch_csa_logger_372963-t1 a-aui_template_weblab_cache_333406-c a-bw_aui_cxc_alert_measurement_1074111-c a-bw_aui_stepper_enable_strategies_1_1330429-t1">

    <div id="a-page">

      <header id="nav-main" class="nav-mobile nav-progressive-attribute nav-locale-us nav-lang-ar nav-ssl nav-unrec nav-blueheaven">
        <div id="navbar" class="nav-t-gateway nav-sprite-v3 celwidget">
          <div id="nav-logobar">
            <div class="nav-left">
              <a href="javascript:" id="nav-hamburger-menu" @click="menuVisible">
                <i class="nav-icon-a11y nav-sprite"></i>
              </a>
              <div id="nav-logo">
                <a href="javascript:void(0);" id="nav-logo-sprites" class="nav-logo-link nav-progressive-attribute">
                  <span class="nav-sprite nav-logo-base"></span>
                </a>
              </div>
            </div>
            <div class="nav-right">
<!--              <div id="nav-progressive-greeting" class="nav-progressive-content">
                <a href="javascript:void(0);" id="nav-logobar-greeting" class="nav-a nav-show-sign-in">
                  تسجيل الدخول ›
                </a>
              </div>-->

              <router-link :to="{ name: 'MemberIndex'}" class='item'>
                <a href="javascript:void(0);" class="nav-a nav-progressive-attribute" id="nav-button-avatar">
                  <i class="nav-icon nav-icon-a11y nav-sprite">حسابك</i>
                </a>
              </router-link>

              <router-link :to="{ name: 'HomeCart'}" class='item'>
                <a href="javascript:void(0);" class="nav-a" id="nav-button-cart">
                  <div id="cart-size" class="nav-cart-0 nav-progressive-attribute">
                    <span class="nav-icon nav-sprite">
  <!--					            <span id="nav-cart-count" class="nav-cart-count nav-progressive-content nav-bluebeacon">0</span>-->
                    </span>
                  </div>
                </a>
              </router-link>

            </div>
          </div>
          <div class="nav-searchbar-wrapper" style="display: flex;" @click="onSearch">
            <form class="nav-searchbar search-big nav-bluebeacon" action="javascript:void(0);" method="get" id="nav-search-form" accept-charset="utf-8">
              <div class="nav-fill">
                <div class="nav-search-field">
                  <input type="text" class="nav-input nav-progressive-attribute" placeholder="بحث في" autocomplete="off" autocorrect="off" autocapitalize="off" dir="auto" value="" id="nav-search-keywords" >
                  <a class="nav-icon nav-sprite nav-search-clear" href="javascript:"></a>
                </div>
              </div>
              <div class="nav-right">
                <div class="nav-search-submit nav-bluebeacon">
                  <input type="submit" class="nav-input" value="اذهب" aria-label="اذهب">
                  <i class="nav-icon nav-sprite"></i>
                </div>
              </div>
            </form>
          </div>

<!--          <div id="nav-disco-bar" class="nav-gwbar-scroll nav-bluebeacon">
            <div id="nav-wrapper" class="nav-gwbar-wrapper nav-bluebeacon">
              <div id="nav-gwbar" class="nav-gwbar-single-row nav-genz nav-gwbar-white nav-gwbar-scroll nav-bluebeacon">
                <ul class="nav-ul">
                  <li class="nav-li">
                    <div class="nav-div">
                      <a id="nav-link-bazaar-in" href="javascript:void(0);" class="nav-a"></a>
                    </div>
                  </li>
                  <li class="nav-li">
                    <div class="nav-div">
                      <a id="video" href="javascript:void(0);" class="nav-a" >فيديو</a>
                    </div>
                  </li>
                  <li class="nav-li">
                    <div class="nav-div">
                      <a id="intlDeals" href="javascript:void(0);" class="nav-a">عروض اليوم</a>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </div>-->

        </div>
      </header>


      <div id="gwm-Deck" class="gwm-u-blackjack-typography aok-clearfix">

        <index-banner v-if="banners && banners.length > 0" :items="banners"></index-banner>

        <div id="gwm-Deck-btf" v-if="floorList">

          <div v-for="(item, index) in floorList">

            <div v-if="item.floor_type == 1" class="gwm-widget pd_rd_w-ApBhw content-id-amzn1.sym.2ed5cb2d-6276-4908-8487-054be25673ca pf_rd_p-2ed5cb2d-6276-4908-8487-054be25673ca pf_rd_r-HPDYJR8R862PRH9X3ZAV pd_rd_wg-WCVLL pd_rd_r-ad23f15b-d11a-4be5-b77a-9f37579030ec c-f csm-strategy-id-61141e5a-c514-4cf8-97cd-451ed5db0e2b celwidget">
              <div class="a-cardui _multi-category-card_style_gwm-multiCategoryCard__1bmE6">
                <div class="a-cardui-header _multi-category-card_style_gwm-multiCategoryCard-header__pAyLH">
                  <h3>
                  <span class="a-truncate" style="line-height:1.3em !important;max-height:2.6em">
                    <span class="a-truncate-cut" style="height: auto;">{{item.floor_name}}</span>
                  </span>
                  </h3>
                </div>
                <div class="a-cardui-body">
                  <div class="_multi-category-card_style_container__3HW_J">
                    <div role="listitem" v-for="(goods, index) in item.goods_list">
                      <a href="javascript:void(0);" class="a-link-normal" @click="goDetail(goods.goods_id)">
                        <img :src="goods.goods_image_url" class="_multi-category-card_image_round-corners__22iOW" width="100%" style="border-radius: 4px;">
                        <div class="a-section a-spacing-none _multi-category-card_style_categoryText__1rWhD">
                          <span class="a-color-base">
                            <span class="a-truncate" style="line-height:1.3em !important;max-height:2.6em">
                              <span class="a-truncate-cut" style="height: auto;">{{goods.goods_name}}</span>
                            </span>
                          </span>
                        </div>
                      </a>
                    </div>
                  </div>
                </div>
                <div class="a-cardui-footer _multi-category-card_style_gwm-link-footer__3EX7d">
                  <div class="a-cardui-link-footer">
                    <a class="a-cardui-link-footer-anchor" :href="item.goods_url">
                      <span class="a-truncate" style="line-height:1.3em !important;max-height:1.3em">
                        <span class="a-truncate-cut" style="height: auto;">عرض المزيد</span>
                      </span>
                    </a>
                  </div>
                </div>
              </div>
            </div>

            <div v-if="item.floor_type == 2" class="gwm-widget pd_rd_w-I3I0p content-id-amzn1.sym.3655834e-df5f-4b01-a5eb-81117f15e22e pf_rd_p-3655834e-df5f-4b01-a5eb-81117f15e22e pf_rd_r-HPDYJR8R862PRH9X3ZAV pd_rd_wg-WCVLL pd_rd_r-ad23f15b-d11a-4be5-b77a-9f37579030ec c-f csm-strategy-id-exports-nta-top-picks-gw csm-asin-B0BHJF2VRN-B06XYHXP8W-B0FR8C52HX celwidget">
              <div class="a-cardui" id="CardInstance71QpxZXIVvNYbhGEJizIZQ">
                <div class="a-cardui-header">
                  <h3>
                  <span class="a-truncate" style="line-height:1.3em !important;max-height:2.6em">
                    <span class="a-truncate-cut" style="height: auto;">{{item.floor_name}}</span>
                  </span>
                  </h3>
                </div>
                <div class="a-cardui-body">
                  <div class="a-section" v-for="(goods, index) in item.goods_list">
                    <a class="a-link-normal _multi-asin-card_style_product__15Yju" href="javascript:void(0);" @click="goDetail(goods.goods_id)">
                      <div class="a-section a-spacing-none _multi-asin-card_image_asin-container__LRY5p _multi-asin-card_image_small-padding__3ZjS-">
                        <img :src="goods.goods_image_url">
                      </div>
                      <div class="a-section _multi-asin-card_style_productDescriptionContainer__2B2iY">
                        <span class="a-color-base">
                          <span class="a-truncate a-size-base" style="line-height:1.3em !important;max-height:2.6em">
                            <span class="a-truncate-cut" style="height: 2.6em;">{{goods.goods_name}}</span>
                          </span>
                        </span>
                        <div class="a-section a-spacing-none">
                          <span>
                            <span class="a-price-range">
                              <span class="a-price">
                                <span dir="ltr">
                                  <span class="a-price-symbol" dir="rtl">؜$</span>
                                  <span class="a-price-whole">{{goods.goods_promotion_price}}</span>
                                </span>
                              </span>
                            </span>
                            <span class="_multi-asin-card_style_spacer__2V1vQ">
                              <span class="a-size-small a-color-secondary">سعر القائمه:</span>
                              <span class="a-price-range">
                                <span class="a-price a-text-price">
                                  <span dir="ltr"><span dir="rtl">؜$</span>{{goods.goods_marketprice}}</span>
                                </span>
                              </span>
                            </span>
                          </span>
                        </div>
                      </div>
                    </a>
                  </div>
                </div>
              </div>
            </div>

            <div v-if="item.floor_type == 3" class="gwm-widget pd_rd_w-MTD29 content-id-amzn1.sym.63a7eb08-827d-416b-8922-e39b09afb9f8 pf_rd_p-63a7eb08-827d-416b-8922-e39b09afb9f8 pf_rd_r-HPDYJR8R862PRH9X3ZAV pd_rd_wg-WCVLL pd_rd_r-ad23f15b-d11a-4be5-b77a-9f37579030ec c-f csm-strategy-id-fb695da0-00d6-4d25-83bd-caadfaf5d1a7 celwidget">
              <div class="a-cardui _category-card_style_gwm-CategoryCard__3u5DD" id="CardInstancelMjPuVNFY0nx9Yv8pBvEMg">
                <div class="a-cardui-header _category-card_style_gwm-CategoryCard-header__1bhZB">
                  <h3>
                    <span class="a-truncate" style="line-height:1.3em !important;max-height:2.6em">
                      <span class="a-truncate-cut" style="height: auto;">{{item.floor_name}}</span>
                    </span>
                  </h3>
                </div>
                <div class="a-cardui-body">
                  <a class="a-link-normal" href="javascript:void(0);" v-for="(goods, index) in item.goods_list" @click="goDetail(goods.goods_id)">
                    <img :src="goods.goods_image_url" class="_category-card_image_round-corners__22iOW" width="100%" style="border-radius: 4px;">
                  </a>
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>

    </div>

    <!-- 版权信息 -->
    <div class="copyright">
      <div v-if="config"><a href="http://www.beian.gov.cn/portal/registerSystemInfo" target="_blank">{{config.wab_number}}</a></div>
      <div v-if="config"><a href="https://beian.miit.gov.cn" target="_blank">{{config.icp_number}}</a></div>
      <div v-if="config">{{config.flow_static_code}}</div>
    </div>

    <div id="hmenu-container" style="display: block;" class="celwidget nav-sprite-v3">
      <div id="hmenu-canvas-background" class="hmenu-dark-bkg-color hmenu-transparent" @click="menuHidden"></div>
      <div id="hmenu-canvas" class="nav-ignore-pinning hmenu-translateX-left">
        <div id="hmenu-content">
          <h1 id="nav-menu-label" class="nav-hidden-aria">تصفح جميع الفئات</h1>
          <div id="hmenu-close-icon" class="nav-sprite hmenu-close-icon" @click="menuHidden"></div>

          <div class="hmenu header-enabled">

            <section>
              <div id="hmenu-header">
                <div id="hmenu-header-bottom" style="margin-top: 16px;">
                  <a id="hmenu-header-title" href="javascript:void(0);">
                    <div id="hmenu-header-title-line1">تصفح</div>
                    <div id="hmenu-header-title-line2">Oubv</div>
                  </a>
                </div>
              </div>
            </section>

            <section>
              <a id="hmenu-home-link" href="javascript:void(0);">
                <div id="hmenu-home-container">
                  <div id="hmenu-home-left">
                    <div id="hmenu-home-text">صفحة Oubv الرئيسية</div>
                  </div>
                  <div id="hmenu-home-right">
                    <div id="hmenu-home-icon" class="nav-sprite"></div>
                  </div>
                </div>
              </a>
            </section>

<!--            <span class="hmenu-separator"></span>
            <section class="category-section">
              <div class="hmenu-item hmenu-title">الأكثر شيوعاً</div>
              <ul>
                <li><a href="javascript:void(0);" class="hmenu-item">قأفضل الأسام</a></li>
              </ul>
            </section>-->

            <span class="hmenu-separator" v-if="catList"></span>
            <section class="category-section" v-if="catList">
              <div class="hmenu-item hmenu-title">أفضل الأقسام</div>
              <ul>
                <li v-for="(cat, index) in catList" @click="goCat(cat.gc_id)">
                  <a href="javascript:void(0);" class="hmenu-item">{{cat.gc_name}}</a>
                </li>
              </ul>
            </section>

          </div>
        </div>
      </div>
    </div>

  </div>
</template>
<script>
import { mapState, mapActions } from 'vuex'
import { Toast } from 'mint-ui'
import SpecialIndex from '../special/Index'
import IndexProductList from './IndexProductList'
import HomeCommonSearch from '../common/HomeCommonSearch'
import IndexBanner from './IndexBanner'
import IndexMenu from './IndexMenu'
import IndexFloorAds from './IndexFloorAds'
import IndexThreeAds from './IndexThreeAds'
import IndexArticle from './IndexArticle'
import {loadScript} from "../../../util/common";
import $ from 'jquery'
import {getFloorProduct, getCatList} from "@/api/homeindex";

export default {
  name: 'HomeIndex',
  data () {
    return {
      uniapp: 0,
      isIos: false,
      isAndroid: false,
      isshowBacktop: true,
      showFooterCurtain: false,
      popular: '',
      sale: 'goods_salenum',
      recently: 'goods_addtime',
      floorList: false,
      catList: false
    }
  },
  components: {
    SpecialIndex,
    IndexProductList,
    HomeCommonSearch,
    IndexBanner,
    IndexMenu,
    IndexFloorAds,
    IndexThreeAds,
    IndexArticle
  },
  mounted () {
  },
  created: function () {

    var u = navigator.userAgent;
    var isAndroid = u.indexOf("Android") > -1 || u.indexOf("Linux") > -1;
    var isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
    if (isAndroid) {
      this.isAndroid = true;
    }
    if (isIOS) {
      this.isIOS = true;
    }

    let _this = this
    loadScript('uniapp', 'https://js.cdn.aliyun.dcloud.net.cn/dev/uni-app/uni.webview.1.5.2.js', function () {
      uni.getEnv(function (res) {
        _this.ifLoaded = true
        if (res.plus) {
          _this.uniapp = 1
        }else{
          if(isAndroid){
            $('.android_app').show()
          }
          if(isIOS){
            $('.ios_app').show()
          }
        }
      })
    })

    this.fetchHomeAd({}).then(
      response => {
      },
      error => {
        Toast(error.message)
      }
    )
    this.fetchHomeArticle({}).then(
      response => {
      },
      error => {
        Toast(error.message)
      }
    )
    this.fetchHomeProduct({"name":this.currency}).then(
      response => {
      },
      error => {
        Toast(error.message)
      }
    )
    this.fetchConfig({}).then(
      response => {
      },
      error => {
        Toast(error.message)
      }
    )
    getFloorProduct().then(res => {
      this.floorList = res.result.floor_list
    })
    getCatList().then(res => {
      this.catList = res.result.cat_list
      /*console.log(this.catList);
      return false;*/
    })
  },
  computed: {
    ...mapState({
      special: state => state.home.special,
      config: state => state.config.config,
      banners: state => state.home.banners,
      navs: state => state.home.navs,
      floorAds: state => state.home.floorAds,
      promotionAds: state => state.home.promotionAds,
      articles: state => state.home.articles,
      hotProducts: state => state.home.hotProducts,
      recentlyProducts: state => state.home.recentlyProducts,
      goodProducts: state => state.home.goodProducts,
      currency: state => state.currency.currency
    })
  },
  methods: {
    ...mapActions({
      fetchHomeAd: 'fetchHomeAd',
      fetchHomeArticle: 'fetchHomeArticle',
      fetchHomeProduct: 'fetchHomeProduct',
      fetchConfig: 'fetchConfig'
    }),
    menuVisible () {
      $('#hmenu-container').addClass('hmenu-visible');
      $('#hmenu-canvas-background').removeClass('hmenu-transparent');
      $('#hmenu-canvas-background').addClass('hmenu-opaque');
      $('#hmenu-canvas').removeClass('hmenu-translateX-left');
      $('#hmenu-canvas').addClass('hmenu-translateX');
      $('.header-enabled').addClass('hmenu-visible');
    },
    menuHidden () {
      $('#hmenu-container').removeClass('hmenu-visible');
      $('#hmenu-canvas-background').addClass('hmenu-transparent');
      $('#hmenu-canvas-background').removeClass('hmenu-opaque');
      $('#hmenu-canvas').addClass('hmenu-translateX-left');
      $('#hmenu-canvas').removeClass('hmenu-translateX');
      $('.header-enabled').removeClass('hmenu-visible');
    },
    onSearch () {
      this.$router.push({ name: 'HomeSearch', params: { isFromHome: true } })
    },
    goDetail (id){
      this.$router.push({ name: 'HomeGoodsdetail', query: { goods_id: id } })
    },
    goCat (cate_id){
      this.$router.push({ name: 'HomeGoodslist', query: { cate_id: cate_id } })
    }
  }
}
</script>
<style scoped>
.m-common-footer-curtain{
  box-sizing:border-box;
  position:fixed;
  z-index:9999;
  top:0;
  right:0;
  bottom:0;
  left:0;
}
.footerCurtain_mask{
  position: absolute;
  z-index:10000;
  width: 100%;
  height: 100%;
  top:0;
  right:0;
  bottom:0;
  left:0;
  background-color:rgba(0,0,0,.3);
}
.m-common-footer-curtain ul{
  list-style:none;
  padding-top:6px;
  overflow:scroll;
  overflow-x:hidden;
  max-height:160px;
}
.m-common-footer-curtain .footer-curtain-wrapper-content{
  box-sizing:border-box;
  width:80%;
  border-radius:4.8px;
  background-color:#fff;
  padding-bottom:6px;
  position: absolute;
  z-index:10001;
  left: 10%;
  top: 150px;
}
.m-common-footer-curtain .footer-curtain-wrapper-content-title{
  position:relative;
  border-bottom:1px solid #e5e5e5;
}
.m-common-footer-curtain .footer-curtain-wrapper-content-title .curtain-title-name{
  text-align:center;
  font-size:13px;
  line-height:36px;
  color:#333;
}
.m-common-footer-curtain .footer-curtain-wrapper-content-title .curtain-title-close{
  position:absolute;
  top:0;
  left:0;
  width:100%;
  height:100%;
  line-height:36px;
  text-align:right;
}
.m-common-footer-curtain .footer-curtain-wrapper-content-title .curtain-title-close span{
  position:absolute;
  top:50%;
  left:12px;
  -webkit-transform:translate(0,-50%);
  transform:translate(0,-50%);
  color: #d9d9d9;
  font-size: 13px;
}
.site-list-item {
  position: relative;
  box-sizing: border-box;
  height: 32px;
  line-height: 32px;
  padding-right: 12px;
}
.site-list-item .site-list-item-name {
  font-size: 12px;
  color: #333;
}
.site-list-item .selected-icon-mask {
  box-sizing: border-box;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 32px;
  line-height: 32px;
  text-align: right;
}
.copyright{
  font-size:.65rem;
  color:#999;
  text-align: center;
  padding:1rem;
}
.app_download{
  border-bottom: 1px solid #e5e5e5;
  padding: 0 0.36rem 0.3rem;
  margin-bottom: 0.36rem;
}
.app_download ul{
  overflow: hidden;
}
.app_download ul li {
  float: left;
  text-align: center;
  width: 33.3333%;
}
.app_download ul li a {
  display: block;
  width: 100%;
  position: relative;
}
.app_download ul li img {
  width: 3rem;
  vertical-align: middle;
}


/*新增css*/
a, a:link, a:visited {
  text-decoration: none;
  color: #ff4040;
}
.a-cardui{
  margin-top:0.077rem;
  margin-bottom:0.077rem;
  background-color:#fff;
  overflow:auto;
  padding:0.4636rem 0.5795rem;
}
.a-cardui .a-cardui-header{
  padding:0rem;
  padding-bottom:0.309rem;
}
#nav-main #navbar .nav-searchbar {
  background: linear-gradient(92.41deg, #f50000, #ff4040);
}
#nav-main #navbar #nav-logobar {
  background: linear-gradient(92.41deg, #f50000, #ff4040);
  border-bottom: 0px solid;
}
#nav-main #navbar #nav-gwbar {
  background: #f50000;
}
#nav-main #navbar #nav-cart-count {
  color: #fff;
  top: 7px;
}
.nav-search-field .nav-input:focus {
  outline: 0.5rem auto #232f3e;
}
#nav-main #navbar .nav-search-submit {
  background: #232f3e;
}
#nav-main #navbar .nav-search-submit .nav-icon {
  background-position: -73px -298px;
  width: 27px;
  height: 25px;
}
#nav-main #navbar #nav-logo .nav-logo-base {
  background-position: -94px -465px;
  width: 79px;
  height: 27px;
}
#hmenu-container .nav-sprite {
  background-image: url("~@/assets/image/new/new-nav-sprite-global-2x_blueheaven-privacy._CB779569577_.png");
  background-size: 275px;
}
#navbar .nav-sprite {
  background-image: url("~@/assets/image/new/new-nav-sprite-global-2x_blueheaven-privacy._CB779569577_.png");
  background-size: 275px;
}
._billboard-card_tallStyle_mobile-double-border-link-focus__3Ra0B:after {
  content: "";
  height: 100%;
  left: 0;
  position: absolute;
  top: 0;
  visibility: hidden;
  width: 100%
}
._billboard-card_tallStyle_mobile-double-border-link-focus__3Ra0B:after {
  border-radius: .5rem;
  box-shadow: inset 0 0 0 .3rem #ff4040, inset 0 0 0 .6rem #fff;
  pointer-events: none
}
._billboard-card_tallStyle_mobile-double-border-link-focus__3Ra0B:focus-visible:after {
  visibility: visible
}
._billboard-card_tallStyle_gwm-tallBillboard__kQsY4 {
  margin-bottom: -25%;
  margin-left: auto;
  margin-right: auto;
  max-width: 1000px;
  position: relative;
  z-index: -1;
  padding: 0;
}
._billboard-card_tallStyle_gwm-tallBillboard__kQsY4 img {
  width: 100%
}
._multi-category-card_style_container__3HW_J {
  grid-gap: 8px;
  display: grid;
  gap: 8px;
  grid-template-columns:minmax(0, 1fr) minmax(0, 1fr)
}
._multi-category-card_style_container__3HW_J img {
  width: 100%
}
._multi-asin-card_style_product__15Yju {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex
}
._multi-asin-card_style_productDescriptionContainer__2B2iY {
  -ms-flex-preferred-size: 70%;
  flex-basis: 70%;
  margin-right: 12px
}
._multi-asin-card_image_asin-container__LRY5p:before{
  content:"";display:block;height:0;padding-bottom:100%
}
._multi-asin-card_image_asin-container__LRY5p {
  -webkit-box-flex: 1;
  -ms-flex: 1;
  flex: 1;
  position: relative
}
._multi-asin-card_image_small-padding__3ZjS- img {
  padding: 4px
}
._multi-asin-card_image_asin-container__LRY5p:after {
  background-color: #0f1111;
  border-radius: 4px;
  content: "";
  height: 100%;
  opacity: .03;
  position: absolute;
  top: 0;
  width: 100%
}
._multi-asin-card_style_spacer__2V1vQ {
  margin-right: 4px
}
._multi-asin-card_image_asin-container__LRY5p img {
  bottom: 0;
  left: 0;
  max-height: 100%;
  max-width: 100%;
  position: absolute;
  right: 0;
  top: 0
}
@supports ((-o-object-fit: contain) or (object-fit:contain)) {
  ._multi-asin-card_image_asin-container__LRY5p img {
    height:100%;
    -o-object-fit: contain;
    object-fit: contain;
    width: 100%
  }
}
._multi-category-card_style_container__3HW_J {
  grid-gap: 8px;
  display: grid;
  gap: 8px;
  grid-template-columns:minmax(0, 1fr) minmax(0, 1fr)
}
._multi-category-card_style_container__3HW_J img {
  width: 100%
}
._billboard-card_tallStyle_mobile-double-border-link-focus__3Ra0B:after {
  content: "";
  height: 100%;
  left: 0;
  position: absolute;
  top: 0;
  visibility: hidden;
  width: 100%
}
._billboard-card_tallStyle_mobile-double-border-link-focus__3Ra0B:after {
  border-radius: .5rem;
  box-shadow: inset 0 0 0 .3rem #ff4040, inset 0 0 0 .6rem #fff;
  pointer-events: none
}
._billboard-card_tallStyle_mobile-double-border-link-focus__3Ra0B:focus-visible:after {
  visibility: visible
}
._billboard-card_tallStyle_gwm-tallBillboard__kQsY4 {
  margin-bottom: -25%;
  margin-left: auto;
  margin-right: auto;
  max-width: 1000px;
  position: relative;
  z-index: -1;
  padding: 0;
}
._billboard-card_tallStyle_gwm-tallBillboard__kQsY4 img {
  width: 100%
}
#gwm-Deck-cf .a-link-normal:focus-visible {
  outline: .5rem auto #ff4040;
  outline-offset: -.2rem
}
#gwm-Deck {
  font-size: 15px;
  color: #111
}
body {
  background-color: #E3E6E6
}
#gw-desktop-herotator .a-carousel-viewport {
  width: 100%
}
#gw-desktop-herotator.tall .a-carousel-viewport {
  height: 78vw !important
}
#gw-desktop-herotator {
  z-index: 0
}
#gw-desktop-herotator .a-carousel-container {
  overflow: visible
}
#gw-desktop-herotator, #gw-desktop-herotator .a-carousel-controls {
  height: 63vw !important
}
#gw-desktop-herotator .a-carousel-center {
  width: 100%
}
.gw-ftGr-desktop-hero .a-cardui {
  margin-top: 0
}
#gw-desktop-herotator .a-carousel-viewport::before {
  content: '';
  position: absolute;
  top: 50vw;
  bottom: 0;
  right: 0;
  left: 0;
  width: 100%;
  height: 28vw;
  z-index: 1;
  pointer-events: none
}
#gw-desktop-herotator.short, #gw-desktop-herotator.short .a-carousel-controls {
  height: 51vw !important
}
#gw-desktop-herotator.short .a-carousel-viewport {
  height: 66vw !important
}
#gw-desktop-herotator.short .a-carousel-viewport::before {
  content: '';
  position: absolute;
  top: 40vw;
  bottom: 0;
  right: 0;
  left: 0;
  width: 100%;
  height: 26vw;
  z-index: 1;
  pointer-events: none
}
.gw-ftGr-desktop-hero .a-cardui img::after {
  content: none;
}
#gw-desktop-herotator .a-carousel-viewport::before, #gw-desktop-herotator.short .a-carousel-viewport::before {
  background: linear-gradient(180deg, rgba(213, 219, 219, 0) 45%, #E3E6E6 100%)
}
.a-truncate {
  position: relative;
  display: inline-block;
  width: 100%;
  overflow: hidden;
}
.a-truncate-cut {
  display: inline-block;
  width: 100%;
  white-space: normal
}
.a-color-base {
  color: #0f1111 !important
}

#nav-gwbar.nav-genz {
  height: 40px;
  padding-top: 12px;
}
#nav-gwbar.nav-gwbar-scroll {
  display: flex;
  overflow-x: scroll;
  -webkit-overflow-scrolling: touch;
  -ms-overflow-style: none;
}
.a-section {
  margin-bottom: 0.48rem;
}
.a-spacing-none, .a-ws .a-ws-spacing-none {
  margin-bottom: 0!important;
}

#hmenu-container #hmenu-canvas #hmenu-content #hmenu-home-link #hmenu-home-container #hmenu-home-right #hmenu-home-icon {
  background-position: -142px -271px;
  height: 19px;
  width: 19px;
}
.a-cardui .a-cardui-footer {
  padding: 0rem;
  padding-top: 0.8rem;
}


</style>